import settings from "../appSettings";

export const imageCdnUrls = {
    //illustrations
    emptyBox: `${settings.cdnUrlIllustrations}/empty-box.svg`,

    //icons

    //logos
    enterpriseLogo: `${settings.cdnUrlLogos}/logo-enterprise.svg`,

    //animations
};
